
// export const FORM_TEXTS = {
//   'amount': {
//     'placeholder': 'How much do you want to raise?',
//     'error': {
//       'min': 'The minimum goal amount is &#x20b9; 2000!',
//       'max': 'The maximum goal amount can be &#x20b9; 5 Crores',
//       'required': 'The minimum goal amount is ₹ 2000!'
//     },
//     'hint': 'Should be minimum &#x20b9; 2000',
//     'popover': {
//       'title': 'How much do you want to raise.',
//       'desc': 'We would suggest entering the exact amount you need to raise. Minimum is amount is 2000/-'
//     }
//   },
//   'name': {
//     'placeholder': 'Your name',
//     'error': {
//       'min': 'your full name should be between 4-30',
//       'max': 'your full name should be between 4-30',
//       'required': 'your full name should be between 4-30'
//     },
//     'popover': {
//       'title': 'Enter your name',
//       'desc': 'E.g. John Doe'
//     }
//   },
//   'title': {
//     'placeholder': 'Describe your fundraiser purpose',
//     'error': {
//       'minlength': 'Fundraiser tiltle should be between 5-75 characters',
//       'maxlength': 'Fundraiser tiltle should be between 5-75 characters',
//       'required': 'Fundraiser tiltle should be between 5-75 characters'
//     },
//     'popover': {
//       'title': 'This is your Fundraiser title.',
//       'desc': 'E.g. Help me empower underprivileged girl children or Help our Aastha fight Cancer!'
//     }
//   },
//   'relation': {
//     'placeholder': 'Whom are you raising funds for?',
//     'popover': {
//       'title': 'Whom are you raising funds for?',
//       'desc': 'E.g. You can create campaign for Personal, Creative or NGO'
//     },
//     'error': {
//       'required': 'Please select a valid option'
//     }
//   },
//   'beneficiaryname': {
//     'placeholder': 'Beneficiary Name',
//     'error': {
//       'maxlength': 'Beneficiary should not exeeds 50 characters',
//       'pattern': 'Please enter a valid name',
//       'required': 'Please select a beneficiary'
//     },
//     'popover': {
//       'title': 'Name for whom you are raising funds.',
//       'desc': 'It is important to inform your supporters of who you are raising money for.'
//     }
//   },
//   'ngo': {
//     'placeholder': 'NGO Name',
//     'error': {
//       'notFound': 'No NGO is found with this name'
//     },
//     'popover': {
//       'title': 'NGO',
//       'desc': 'NGO'
//     }
//   },
//   'cause': {
//     'placeholder': 'Please choose a cause',
//     'popover': {
//       'title': 'This is your cause',
//       'desc': 'This is to help like-minded, kind people find your fundraiser on our website.'
//     },
//     'error': {
//       'required': 'Please choose a cause'
//     }
//   },
//   'end_date': {
//     'placeholder': 'End Date',
//     'error': {
//       'minlength': 'Fundraiser end date cannot be older than today!',
//     },
//     'popover': {
//       'title': 'Fundraiser End Date',
//       'desc': 'Your Fundraiser will end on this date.'
//     }
//   },
//   'fundraiser_image': {
//     'placeholder': 'Add fundraiser Image/Video',
//     'popover': {
//       'title': 'Upload a Fundraiser Image/Video',
//       'desc': `This is going to be the face of your fundraiser.
//                Great photos will help your fundraiser raise more money.
//                Add non-pixelated, high resolution, clear images/videos that best describe your fundraiser.`,
//       'eg': `Ideal Size: 750x435. If it’s bigger, don’t worry, you can crop it while uploading.`
//     }
//   },
//   'beneficiary_image': {
//     'placeholder': 'Add Benificiary Image',
//     'popover': {
//       'title': 'This is the person whom you are raising money for.',
//       'desc': `Adding an image increase donations by 50%.
//                We may request additional information from you to verify that the funds raised will go to this beneficiary.`
//     }
//   },
//   'short_description': {
//     'placeholder': 'Add a Short Description',
//     'error': {
//       'minlength': 'Minimum 10 characters required',
//       'maxlength': 'Short Description should not exeeds 120 characters'
//     },
//     'popover': {
//       'title': 'Explain your fundraiser in short',
//       'desc': `Write a short blurb for your fundraiser in 120 characters.`,
//       'eg': `E.g. Aastha is only 8 years old, support her fight against Acute Lymphoblastic Leukemia`
//     }
//   },
//   'url': {
//     'placeholder': 'Create Your Fundraiser URL',
//     'error': {
//       'minlength': 'Minimum 5 characters required',
//       'pattern': 'Invalid URL',
//       'used': 'Short URL has already been taken',
//     },
//     'popover': {
//       'title': 'shorturl',
//       'desc': 'Create an URL which relates to your fundraiser and is easy to remember.'
//     }
//   },
//   'city': {
//     'placeholder': 'Enter Your City',
//     'popover': {
//       'title': 'Enter your fundraiser city',
//       'desc': 'This is the city in which this fundraiser will run.'
//     }
//   },
//   'mobile_number': {
//     'placeholder': 'Your Mobile Number',
//     'popover': {
//       'title': 'Enter your contact number',
//       'desc': 'Provide an active contact number'
//     }
//   },
//   'description_story': {
//     'placeholder':
//       'Write a story that does justice to your cause and makes the supporter click the donate button.'
//       + '\n\nFollow these steps:'
//       + '\n* Talk about who you are raising funds for, be it yourself or your loved one.'
//       + '\n* Explain why you are raising funds.'
//       + '\n* Make an appeal to your supporters.',
//     'popover': {
//       'title': 'Tell us more about your Fundraiser',
//       'desc': 'Tell Your Story'
//     }
//   },
//   'reward_title': {
//     'placeholder': 'Reward Title',
//     'error': {
//       'minlength': 'Minimum 5 characters required',
//       'maxlength': 'Reward Title should not exeeds 50 characters'
//     },
//     'popover': {
//       'title': 'Enter Reward Title',
//       'desc': 'Put an apealing reward title'
//     }
//   },
// };
import { ENGLISH } from './language/english';
import { HINDI } from './language/hindi';
import { TELUGU } from './language/telugu';
import { TAMIL } from './language/tamil';



export const FORM_TEXTS = {
  English: ENGLISH,
  Hindi: HINDI,
  Telugu: TELUGU,
  Tamil: TAMIL
};
